import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showErrors } from '../../modules/general';
import { apiFetch, apiSearch } from '../../modules/utility';
const apiBase = 'usdgBol';

const mapStateToProps = (state, ownProps) => {
	let usdgBols;
	let usdgBol;
	let usdgBolId;

	if (state.lists.usdgBolIds) {
		usdgBols = _.map(state.lists.usdgBolIds, (id) => state.maps.usdgBol[id]);
	}

	if (ownProps.usdgBol) {
		usdgBol = ownProps.usdgBol;
	} else {
		usdgBolId = ownProps.usdgBolId
			? ownProps.usdgBolId
			: _.get(ownProps, ['match', 'params', 'usdgBolId']);
		usdgBol = _.get(state.maps, ['usdgBol', usdgBolId]);
	}

	return {
		usdgBol,
		usdgBols,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		supplierMap: state.maps.supplier,
		stationDeliveryMap: state.maps.stationDelivery,
		stationMap: state.maps.station,
		terminalMap: state.maps.terminal,
	};
};

const search = (p = {}) => {
	const { afterDateTime, callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: {
				afterDateTime,
			},
			dispatch,
			callback,
		});
	};
};

const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getUsdgBol: get,
			usdgBolSearch: search,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
